import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class LicenseTypeDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  getLicenseTypeOptionsAsync(query: string, timeout: Promise<any> = null): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('licenseTypes/options', request, timeout);
  }

  getLicenseTitleStatesAsync(cancellationToken: Promise<any>): Promise<ListOption<string>[]> {
    return this.httpClient.getJsonAsync<ListOption<string>[]>('LicenseTitles/GetLicenseTitleStates', null, cancellationToken);
  }
}
